<div bsModal #modelDetails="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ keyboard: false, backdrop: 'static' }">
    <div class="modal-dialog" style="width: 1000px;">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" aria-hidden="true" (click)="close()">&times;</button>
                <h4 class="modal-title" id="myModalLabel">{{ model.Name }} &bull; Details</h4>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="pull-right">
                            <span>Status </span>
                            <i class="fa fa-ellipsis-v"></i>
                            <span> {{ model.Active ? 'Active' : 'Inactive' }}</span>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6" style="height: 180px;">
                        <div class="panel panel-success">
                            <div class="panel-heading">
                                <h4>
                                    <span>Mine Sites</span>
                                    <span class="pull-right badge">{{ modelMinesites.length }}</span>
                                </h4>
                            </div>
                            <div class="panel-body" style="height: 120px; overflow-y: scroll;">
                                <div class="list-group">
                                    <div class="list-group-item list-group-item-info" *ngFor="let minesite of modelMinesites">
                                        <b>{{ minesite.Name }}</b>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6" style="height: 180px;">
                        <div class="panel panel-success">
                            <div class="panel-heading">
                                <h4>
                                    <span>Equipment</span>
                                    <span class="pull-right badge">{{ modelEquipment.length }}</span>
                                </h4>
                            </div>
                            <div class="panel-body" style="height: 120px; overflow-y: scroll;">
                                <div class="list-group">
                                    <div class="list-group-item list-group-item-info" *ngFor="let equipment of modelEquipment">
                                        <div class="list-group-item-heading">
                                            <b>{{ equipment.Serial }} ({{ equipment.PoweredBy.Name }})</b>
                                        </div>
                                        <div class="list-group-item-text" *ngIf="equipment.Minesite">
                                            Currently at: {{ equipment.Minesite?.Name }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <br />
                <div class="row">
                    <div class="col-lg-6" style="height: 180px;">
                        <div class="panel panel-success">
                            <div class="panel-heading">
                                <h4>
                                    <span>Associated Accounts</span>
                                    <span class="pull-right badge">{{ modelUsers.length }}</span>
                                </h4>
                            </div>
                            <div class="panel-body" style="height: 120px; overflow-y: scroll;">
                                <div class="list-group">
                                    <div class="list-group-item list-group-item-info" *ngFor="let user of modelUsers">
                                        <div class="list-group-item-heading">
                                            <b>{{ user.FirstName }} {{ user.LastName }}</b>
                                        </div>
                                        <div class="list-group-item-text">
                                            {{ user.UserName }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6" style="height: 180px;">
                        <div class="panel panel-success">
                            <div class="panel-heading">
                                <h4>
                                    <span>Associated Documentation</span>
                                    <span class="pull-right badge">{{ modelDocuments.length }}</span>
                                </h4>
                            </div>
                            <div class="panel-body" style="height: 120px; overflow-y: scroll;">
                                <div class="list-group">
                                    <div class="list-group-item list-group-item-info" *ngFor="let document of modelDocuments">
                                        <div class="list-group-item-heading">
                                            <b>{{ document.ProductName }} ({{ document.Version }})</b>
                                        </div>
                                        <div class="list-group-item-text">
                                            {{ document.FileName }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" (click)="close()">Close</button>
            </div>
        </div>
    </div>
</div>
